<footer class="app-footer text-right mx-3">
	<span class="small">Copyright &copy; <a href="https://www.kondorcs.it">Kondor CS S.R.L.</a></span>
</footer>
